import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveStoreRules, getStoreRuleByID, saveStoreRulesContent } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeStoreRulesForm } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { selectStoreRulesForm, selectStoreRulesContentForm } from 'selectors/entitySelector';
import { storeRulesEditCrumb, storeRulesAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import DialogInput from 'screens/components/advanced/DialogInput';

const storeRulesSaveComponentName = "storeRules";
const storeRulesContentSaveComponentName = "storeRulesContent";

const customContentStyle = {
    width: '95%',
    maxWidth: 'none'
};
class storeRulesSave extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: true,
            dialogOpen: false
        };
    }

    componentWillMount() {
        const storeRulesId = this.props.params ? this.props.params.id : null;
        //if true dispatch an action to retrive doctor data from API and set Status to EDIT
        if (storeRulesId) {
            this.setState({ status: "EDIT" });
            let model = {
                id: storeRulesId,
                compName: storeRulesSaveComponentName
            };
            this.props.getStoreRuleByID(model);
        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(storeRulesSaveComponentName);
        }
    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if (newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.saveContentSuccess != null && newProps.saveContentSuccess !== this.props.saveContentSuccess) {
            this.closeDialog();
            const storeRulesId = this.props.params ? this.props.params.id : null;
            let model = {
                id: storeRulesId,
                compName: storeRulesSaveComponentName
            };
            this.props.getStoreRuleByID(model);
        }
    }

    //when Vendor is saved successfully
    saveSuccess = () => {
        this.props.showSnackbar("save success");
        this.props.navigate('/ecommerce/storerules');
    }

    //when Vendor is not saved, failure
    saveFailure = () => {
        this.props.showError("save error");
    }

    saveStoreRules = () => {
        let storeRulesModel = this.props.storeRulesModel;
        storeRulesModel.compName = storeRulesSaveComponentName;
        storeRulesModel.Id = this.state.status === "EDIT" ? this.props.params.id : 0;
        this.props.saveStoreRules(storeRulesModel);
    };

    saveStoreRuleContent = () => {
        console.log('i want to save store rule content');
        let storeRulesContentModel = this.props.storeRulesContentModel;
        storeRulesContentModel.compName = storeRulesContentSaveComponentName;
        storeRulesContentModel.WebStoreRulesId = this.props.params.id;
        this.props.saveStoreRulesContent(storeRulesContentModel);
    }

    cancel = () => {
        this.props.navigate('/ecommerce/storerules');
    };

    openDialog = () => {
        this.setState({
            dialogOpen: true
        });
    }

    closeDialog = () => {
        this.setState({
            dialogOpen: false
        });
    }

    render() {
        const p = this.props;
        const breadCrumbPage = this.state.status === 'EDIT' ? storeRulesEditCrumb : storeRulesAddCrumb

        return (
            <Grid headerContent={breadCrumbPage}>
                <CardSimple className="paddingForMobileDevices mt-2 pa-2">
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4>Store Rules</h4>
                        </div>
                        {
                            this.state.status === 'EDIT' && (
                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 text-right mt-20px">
                                    <Button
                                        type="AddButton"
                                        mini={true}
                                        label="ADD NEW CONTENT"
                                        className="bg-light-green POListBtn"
                                        onTouchTap={() => this.openDialog()}
                                    />
                                </div>
                            )
                        }
                        <div className="col-lg-12">
                            <TextInput name={`${storeRulesSaveComponentName}Name`}
                                floatingLabelText="Name" fullWidth={true} hintText="Name" />
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <ToggleInput className="vendor_status btnToggleLabel" name={`${storeRulesSaveComponentName}Status`} label="Status" />
                        </div>
                    </div>
                    <div className="row">
                        {
                            (this.props.storeRule && this.state.status === 'EDIT' ? this.props.storeRule.webStoreRulesContent ? this.props.storeRule.webStoreRulesContent : [] : []).map((item, index) => {
                                return (
                                    <div className="col-lg-12" key={index}>
                                        <TextInput name={`storeRulesContent_${item.id}`}
                                            floatingLabelText="Content" fullWidth={true} hintText="Content" />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Button name="buttonSave"
                                className="pull-right btnNewBrandPOS"
                                label={LOOKUP.vendor.controls.saveButton}
                                primary={true}
                                onTouchTap={() => this.saveStoreRules()} />

                            <Button name="cancelButton"
                                type="CancelButton"
                                className="pull-right btn-space btnCleanSearch"
                                label={LOOKUP.vendor.controls.cancelButton}
                                onTouchTap={() => this.cancel()} />
                        </div>
                    </div>
                </CardSimple>
                <DialogInput
                    title={<DialogHeaderWithClose text="Add New Content" handleClose={() => this.closeDialog()} />}
                    modal={true}
                    open={this.state.dialogOpen}
                    autoScrollBodyContent={true}
                    handleClose={() => this.closeDialog()}
                    contentStyle={customContentStyle}>
                    <div className="no-crumb">
                        <TextInput name={`${storeRulesSaveComponentName}Content`}
                            floatingLabelText="Content" fullWidth={true} hintText="Content" />
                        <Button name="buttonSave"
                            className="pull-right"
                            label={LOOKUP.vendor.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.saveStoreRuleContent()} />
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        storeRulesModel: selectStoreRulesForm(state, storeRulesSaveComponentName),
        storeRulesContentModel: selectStoreRulesContentForm(state, storeRulesSaveComponentName),
        saveSuccess: state.form[storeRulesSaveComponentName + "SaveSuccess"],
        saveContentSuccess: state.form[storeRulesContentSaveComponentName + "SaveSuccess"],
        storeRule: state.entity.storeRule
    };
}

function mapDispatchToProps(dispatch) {
    return {
        saveStoreRules: (model) => dispatch(saveStoreRules(model)),
        saveStoreRulesContent: (model) => dispatch(saveStoreRulesContent(model)),
        init: (name) => dispatch(initializeStoreRulesForm(name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        getStoreRuleByID: (model) => dispatch(getStoreRuleByID(model)),
        showError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(storeRulesSave));
